export class ToggleMenu {
    constructor(toggleButtonClass, toggleClass = 'navigation-is-active', buttonToggleClass = 'is-active') {
        this.button = document.getElementsByClassName(toggleButtonClass)[0];
        this.toggleClass = toggleClass;
        this.buttonToggleClass = buttonToggleClass;
        this.expanded = this.button.getAttribute("aria-expanded");

        this.events();
    }

    click(event) {
        event.preventDefault();

        if(true === this.expanded) {
            this.expanded = false;
        } else {
            this.expanded = true;
        }

        document.body.classList.toggle(this.toggleClass);
        this.button.classList.toggle(this.buttonToggleClass);
        this.button.setAttribute("aria-expanded", this.expanded);

        return false;
    }
  
    events() {
        this.button.addEventListener("mouseup", this.click.bind(this), false);
        this.button.addEventListener("touchend", this.click.bind(this), false);
    }
}